import { createIntl, createIntlCache } from 'react-intl';
import { getLang, DNBDefaultLanguage } from '@dnb/locale';
import { translations } from '@pm-netbank/translations';

interface LocaleTranslations {
  [key: string]: string;
}
export interface Translations {
  [key: string]: LocaleTranslations;
}

export interface IntlConfig {
  defaultLocale: string;
  locale: string;
  key: string;
  messages: LocaleTranslations;
}

export function getIntlConfig(
  translations: Translations,
  locale?: string
): IntlConfig {
  return {
    defaultLocale: DNBDefaultLanguage,
    locale: locale || DNBDefaultLanguage,
    key: locale, // triggers re-rendering of components if locale changes
    messages: translations[locale || DNBDefaultLanguage],
  };
}

const locale = getLang();

const intl = createIntl(
  {
    defaultLocale: DNBDefaultLanguage,
    locale: locale,
    messages: (translations as Translations)[locale],
  },
  createIntlCache()
);

export function getIntl() {
  return intl;
}
